import { Box, Loader, Stepper, StepperItem } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import { RefObject, useContext } from 'react';

import { ProductTradeInContext } from '../Context';
import BrandSelector from './BrandSelector';
import ConditionSelector from './ConditionSelector';
import Instructions from './Instructions';
import ProductSelector from './ProductSelector';

const Steps = ({
  currentStep,
  scrollRef
}: {
  currentStep: number;
  scrollRef: RefObject<HTMLDivElement | null>;
}) => {
  const { brands, isLoading } = useContext(ProductTradeInContext);
  const { t } = useTranslation('webshop.productTradeIn');

  if (!brands || isLoading) {
    return (
      <>
        <Box sx={{ minHeight: '20rem', position: 'relative' }}>
          <Loader />
        </Box>
        <Box pt={600} />
      </>
    );
  }

  const steps = [
    {
      name: 'brand',
      component: <BrandSelector />
    },
    {
      name: 'product',
      component: <ProductSelector scrollRef={scrollRef} />
    },
    {
      name: 'condition',
      component: <ConditionSelector />
    },
    {
      name: 'instructions',
      component: <Instructions />
    }
  ];

  return (
    <>
      <Stepper activeStep={currentStep} theme='flame-truck'>
        {steps.map(({ name }) => (
          <StepperItem key={name} label={t(`steps.${name}`)} />
        ))}
      </Stepper>
      {steps[currentStep].component}
    </>
  );
};

export default Steps;
